import { render } from "./ReturnIcon.vue?vue&type=template&id=058806f8"
import script from "./ReturnIcon.vue?vue&type=script&lang=js"
export * from "./ReturnIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__